import { format } from 'date-fns'
import { lv, enUS } from 'date-fns/locale/index.js'

const locales = { lv, en: enUS }

export default function (date, formatStr = 'PP', locale = 'en') {
  return format(date, formatStr, {
    locale: locales[locale]
  })
}
